const SGM_CLICKABLE_ROUTES = new Set([
  'DataDisplay',
  'SgmMenu'
]);

const SGM_DISABLED_MENUS = new Set([
  'FordConfig',
  'TestSn',
  'SnMycarInfo',
  'BlackSn',
  'VinList',
  'VinIMMO',
  'FileDownload',
  'DeliverFunction',
  'ProductGuide',
  'Mazda',
  'ApiAnalysis',
  'ApiDoc',
  'Drawerlog',
  'QuerySettings'
]);

const SGM_DISABLED_TOP_ENTRIES = new Set(['1', '2', '3', '4']);

export function permissionTemplateOf(userData) {
  return String(
    userData?.permissionTemplate ||
    userData?.permissions?.template ||
    ''
  ).trim().toUpperCase();
}

export function permissionTemplatesOf(userData) {
  const source =
    userData?.permissionTemplates ||
    userData?.permissions?.templates ||
    [];

  if (!Array.isArray(source)) {
    const single = permissionTemplateOf(userData);
    return single && single !== 'MULTI' ? [single] : [];
  }

  return [...new Set(
    source
      .map((item) => String(item || '').trim().toUpperCase())
      .filter(Boolean)
  )];
}

export function isSgmUser(userData) {
  if (isAdminUser(userData)) {
    return false;
  }
  const templates = permissionTemplatesOf(userData);
  if (templates.length > 0) {
    return templates.length === 1 && templates[0] === 'SGM';
  }
  return permissionTemplateOf(userData) === 'SGM';
}

export function isAdminUser(userData) {
  return String(userData?.job || '').trim() === '管理员';
}

export function canUseDownloadMaintenanceTools(userData) {
  const job = String(userData?.job || '').trim();
  return job === '开发' || isAdminUser(userData);
}

export function isSsvipUser(userData) {
  return isAdminUser(userData) ||
    (!isSgmUser(userData) && String(userData?.webstatus || '').trim().toUpperCase() === 'SSVIP');
}

export function routeRequiresSsvip(route) {
  const matched = Array.isArray(route?.matched) ? route.matched : [];
  return matched.some((record) => record?.meta?.requiresSsvip === true);
}

export function routeRequiresSgm(route) {
  const matched = Array.isArray(route?.matched) ? route.matched : [];
  return matched.some((record) => record?.meta?.requiresSgm === true);
}

export function menuItemState(userData, routeName) {
  if (isAdminUser(userData)) {
    return 'enabled';
  }

  if (isSgmUser(userData)) {
    if (SGM_CLICKABLE_ROUTES.has(routeName)) {
      return 'enabled';
    }
    if (SGM_DISABLED_MENUS.has(routeName)) {
      return 'disabled';
    }
    return 'hidden';
  }

  if (routeName === 'SgmMenu') {
    return 'hidden';
  }
  if (routeName === 'FordConfig') {
    return isSsvipUser(userData) ? 'enabled' : 'hidden';
  }
  if (routeName === 'DataSwitch') {
    return 'hidden';
  }
  return 'enabled';
}

export function topEntryState(userData, value) {
  if (isSgmUser(userData) && SGM_DISABLED_TOP_ENTRIES.has(String(value))) {
    return 'disabled';
  }
  return 'enabled';
}

export function canAccessRoute(userData, route) {
  if (isAdminUser(userData)) {
    return true;
  }

  if (isSgmUser(userData)) {
    return SGM_CLICKABLE_ROUTES.has(route?.name);
  }

  if (routeRequiresSgm(route)) {
    return false;
  }

  if (!routeRequiresSsvip(route)) {
    return true;
  }

  return isSsvipUser(userData);
}
